const CANONICAL_PATHS_WITHOUT_TRAILING_SLASH = ["/pt/unidos-pelo-hexa"];

const normalizeTrailingSlash = () => {
  if (typeof window === "undefined") {
    return;
  }

  const pathPrefix =
    typeof __PATH_PREFIX__ !== "undefined" ? __PATH_PREFIX__ : "";

  // Gatsby normalizes the prefixed root page from "/prefix" to "/prefix/".
  // These LPs are intentionally served without the final slash.
  if (window.pagePath === "/" && window.location.pathname === pathPrefix) {
    window.pagePath = "";
  }

  const { pathname, search, hash } = window.location;

  for (const canonicalPath of CANONICAL_PATHS_WITHOUT_TRAILING_SLASH) {
    if (pathname === `${canonicalPath}/`) {
      window.history.replaceState(
        window.history.state,
        "",
        `${canonicalPath}${search}${hash}`
      );
      return;
    }
  }
};

exports.onClientEntry = normalizeTrailingSlash;
exports.onRouteUpdate = normalizeTrailingSlash;
